import { UAParser } from 'ua-parser-js'
import { Timestamp } from '@weblite/ts-action/types'
import { formatDate, formatClock } from '$func/time'

export function formatSessionDate(date: Timestamp) {
  return `${formatClock(new Date(date))} ${formatDate(new Date(date))}`
}

export function getSessionInfo(userAgent: string) {
  const parser = new UAParser(userAgent)
  const { name: OS_NAME, version: OS_VERSION } = parser.getOS()
  const { vendor: DEVICE_VENDOR, model: DEVICE_MODEL } = parser.getDevice()

  return {
    os: OS_NAME && `${OS_NAME} ${OS_VERSION}`,
    device: DEVICE_VENDOR && `${DEVICE_VENDOR} ${DEVICE_MODEL}`,
  }
}
